<template>
  <div id="app">
    <router-view :current-lang="currentLang" @change-lang="changeLang" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentLang: localStorage.getItem('FULFILLDROP_lang') || 'en'
    }
  },
  methods: {
    changeLang(lang) {
      this.currentLang = lang
      localStorage.setItem('FULFILLDROP_lang', lang)
    }
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #28b5c1;
  --primary-dark: #1e9aa5;
  --primary-light: #3ec4cf;
  --secondary-color: #f59e0b;
  --secondary-dark: #d97706;
  --accent-color: #f97316;
  --accent-light: #fb923c;
  --accent-green: #10b981;
  --accent-purple: #1e9aa5;
  --accent-blue: #3b82f6;
  --brand-tint: #e6f7f9;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --background-light: #f8fafc;
  --background-white: #ffffff;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --border-radius: 12px;
  --transition: all 0.3s ease;
  --animation-duration: 0.8s;
  --hover-scale: 1.03;
  --card-hover-y: -5px;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background-color: var(--background-light);
  scroll-behavior: smooth;
  font-size: 16px;
  overflow-x: hidden;
}

#app {
  overflow-x: hidden;
}

img,
svg {
  max-width: 100%;
}

h1, h2, h3, h4, p, span, li {
  overflow-wrap: anywhere;
}
</style>